var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row justify-content-center my-2" },
    [
      _vm.link
        ? _c(
            "router-link",
            {
              class: ["btn", "btn-navigation", _vm.color, "nohover"],
              attrs: {
                to: { name: _vm.link, query: _vm.query },
                type: "button"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("click")
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
          )
        : _vm.disabled
        ? _c(
            "button",
            {
              class: [
                "btn",
                "btn-navigation",
                _vm.color,
                "nohover",
                "disabled"
              ],
              attrs: { disabled: "" }
            },
            [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
          )
        : _c(
            "button",
            {
              class: ["btn", "btn-navigation", _vm.color, "nohover"],
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("click")
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.text) + "\n  ")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }